/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Onenote_Description_2Inputs */

const en_features_onenote_description_2 = /** @type {(inputs: Features_Onenote_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No need to manually type notes anymore. Easily export your notes at a later time!`)
};

const es_features_onenote_description_2 = /** @type {(inputs: Features_Onenote_Description_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡No necesitas escribir notas manualmente nunca más. Exporta tus notas fácilmente cuando quieras!`)
};

/**
* | output |
* | --- |
* | "No need to manually type notes anymore. Easily export your notes at a later time!" |
*
* @param {Features_Onenote_Description_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_onenote_description_2 = /** @type {((inputs?: Features_Onenote_Description_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Onenote_Description_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_onenote_description_2(inputs)
	return en_features_onenote_description_2(inputs)
});